import AOS from 'aos';
import jQuery from 'jquery';
AOS.init({
    startEvent: 'load'
});

(function ($) {
    const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const refreshAOS = debounce(() => {
        AOS.refresh();
    }, 500);

    const $accordionItems = $('.accordion-item');
    if ($accordionItems.length) {
        $accordionItems.each(function () {
            $(this).on("click", refreshAOS);
        });
    }

    const $tabLinks = $('.tab-link');
    if ($tabLinks.length) {
        $tabLinks.each(function () {
            $(this).on("click", refreshAOS);
        });
    }
})(jQuery);
